import PropTypes from 'prop-types';
import React from 'react';

const StatBlock = ({ label, value, onChange, onRoll, readOnly = false, rollLabel }) => {
  const handleKeyDown = (event) => {
    if (onRoll && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      onRoll();
    }
  };

  return (
    <div
      className={`stat-block${onRoll ? " stat-block-rollable" : ""}`}
      onClick={(event) => {
        if (onRoll && event.target.tagName !== "INPUT") onRoll();
      }}
      onKeyDown={handleKeyDown}
      role={onRoll ? "button" : undefined}
      tabIndex={onRoll ? 0 : undefined}
      aria-label={onRoll ? rollLabel : undefined}
    >
      <label onClick={onRoll ? (event) => event.preventDefault() : undefined}>{label}</label>
      <input
        type="number"
        className="stat-input"
        value={value}
        onChange={onChange}
        onClick={onRoll ? (event) => event.stopPropagation() : undefined}
        readOnly={readOnly}
        inputMode="numeric"
      />
    </div>
  );
};

StatBlock.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func,
  onRoll: PropTypes.func,
  readOnly: PropTypes.bool,
  rollLabel: PropTypes.string,
};

export default StatBlock;
